import { FC, useEffect } from "react";
import { EBtnType } from "@/models/common/enums";
import { MDBRow } from "mdb-react-ui-kit";
import Btn from "@/components/common/Btn";
import { useMutation } from "@tanstack/react-query";
import { useStore } from "@/store/index";
import { IUser } from "@/models/user";
import { deletePaymentCard } from "@/utils/queries/user-queries";

const DeleteCardModalBody: FC<{
    cardToken: string;
    onSuccess: () => void;
}> = ({ cardToken, onSuccess }) => {
    const setErrorMessage = useStore(state => state.setErrorMsg);
    const setSuccessMessage = useStore(state => state.setSuccessMsg);
    const dispatch = useStore(state => state.dispatchCommon);
    const dispatchUser = useStore(state => state.dispatchUser);

    const { mutate: deleteCard, isLoading } = useMutation({
        mutationFn: deletePaymentCard,
        onSettled: () => {
            dispatch({ type: "SET_LOADER_PAGE", payload: false });
        },
        onError: err => setErrorMessage(err as never),
        onSuccess: (userDetail: IUser) => {
            dispatchUser({
                type: "UPDATE_USER_DETAIL",
                payload: { paymentMethods: userDetail.paymentMethods },
            });
            onSuccess();
            setSuccessMessage("Card deleted successfully!");
        },
    });

    useEffect(() => {
        dispatch({ type: "SET_LOADER_PAGE", payload: isLoading });
    }, [isLoading]);

    return (
        <MDBRow className="g-0 py-2">
            <Btn
                btnType={EBtnType.PRIMARY}
                onClick={() => deleteCard(cardToken)}
                fullWith
                className="mt-4"
                disabled={isLoading}
            >
                Delete
            </Btn>
        </MDBRow>
    );
};

export default DeleteCardModalBody;
